module.exports = __webpack_public_path__ + "img/uz_02.96effb57.svg";